/**
 *
 * @param {Number} TIME
 * @param {Number} DURATION
 * @param {StepProps} step
 * @param {Boolean} enter
 * @param {Boolean} coords
 * @param {Number} ratio
 * @returns
 */
const getStepStartTime = (TIME, DURATION, step, enter, coords, ratio = 1) => {
  const percents = /** @type {Number} */ (step.get("switch-percents"));

  /** Current step offsets (start, end) */
  const offsets = /** @type {Array<Number>} */ (step.get("offsets"));
  const start = offsets[0] * ratio;
  const end = offsets[1] * ratio;

  if (coords) {
    return start;
  }

  if (enter) {
    /** Check if the step is completed */
    const completed = percents * DURATION > start;

    /** How far the is the current duration percents (time) from te "start" of the step */
    const difference = completed ? 0 : start - percents * DURATION;

    /** If the current step is completed, do not add any difference to the start time */
    return TIME + difference;
  } else {
    /** Check if the step is completed */
    const completed = percents * DURATION > end;
    // console.log(step.get("data"), percents, DURATION, end);
    /** How far the is the current duration percents (time) from te "end" of the step */
    const difference = completed ? percents * DURATION - end : 0;

    /** If the current step is not completed, do not add any difference to the start time */
    return TIME + difference;
  }
};

export default getStepStartTime;
